// extracted by mini-css-extract-plugin
module.exports = {"infoRow":"styles_infoRow__iMQap","title":"styles_title__3wKdq","value":"styles_value__1Wt9h","autobookInfoFlexP":"styles_autobookInfoFlexP__1anha"};